import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "src/app/app.component";
import { DataService, Response } from "src/app/dataService/data.service";
import { AlertService } from "src/app/services/alert.service";
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from "ngx-intl-tel-input";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-website-signup",
  templateUrl: "./website-signup.component.html",
  styleUrls: ["./website-signup.component.scss"],
})
export class WebsiteSignupComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  @ViewChild("accessSuccessModal", { static: true })
  accessSuccessModal: ElementRef;
  @ViewChild("accessDeniedpopModal", { static: true })
  accessDeniedpopModal: ElementRef;
  createdBusinessId: any;
  isExistingOwner: boolean = false;
  business_domain: any[] = [];
  business_detail_form: FormGroup;
  images: { id: string; image_link: string }[];
  products: any[] = [];
  selectedProduct: boolean[] = [];
  product_array: any[] = [];
  emailnotvalid: boolean = true;
  business_details_submit: boolean;
  registerForm2: FormGroup;
  newOutlet_id: string;
  submitClicked: boolean;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  CountryISO312: any;
  selectedCountry = { India: "in" };
  PhoneNumberFormat = PhoneNumberFormat;

  token: any;

  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  onlyCountries: any;
  countryList: any;
  countryLoader: boolean;
  onboardJsonArray = [];
  existingUserSuccessMsg =
    "Business created successfully. Looks like you already have an account, you will be redirected to the sign-in page to continue.";

  errorUiVisible: boolean = false;
  errorUiMsg: string = "";

  utmParams = {
    utm_source: null,
    utm_medium: null,
    utm_term: null,
    utm_campaign: null,
  };

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private modalService: NgbModal,
    private router: Router,
    private alertService: AlertService,
    private commonService: CommonService,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    let qParams;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      qParams = { ...params.keys, ...params };
    });
    if (qParams?.utm_source) {
      this.utmParams.utm_source = qParams.utm_source;
    }
    if (qParams?.utm_medium) {
      this.utmParams.utm_medium = qParams.utm_medium;
    }
    if (qParams?.utm_campaign) {
      this.utmParams.utm_campaign = qParams.utm_campaign;
    }
    if (qParams?.utm_term) {
      this.utmParams.utm_term = qParams.utm_term;
    }

    this.getProductDataForDescription();

    this.countryLoader = false;
    this.HttpService.getRequestAdmin({
      customApiUrl: `${this.BASE_URL.COUNTRY_API}`,
    }).subscribe((data) => {
      let res: Response;
      res = data;
      if (res.code === 200) {
        this.countryList = res.data["countries"];
        this.CountryISO312 = this.countryList.map((e) => {
          return e.country_code.toLowerCase();
        });

        this.onlyCountries = this.CountryISO312;
        this.countryLoader = true;
      }
    });
    // this.HttpService.getRequestAdminAuth({
    //   customApiUrl: `${this.BASE_URL.TOKEN_VALIDATE}`,
    // }).subscribe(
    //   (data) => {
    //     let res: Response;
    //     res = data;
    //   },
    //   (error) => {
    //     console.log(error);

    //     if (error.status != 200 && error.status != 201 && error.status != 202) {
    //       this.modalService.open(this.accessDeniedpopModal, {
    //         backdropClass: "light-blue-backdrop",
    //         backdrop: "static",
    //         keyboard: false,
    //       });
    //     }
    //   }
    // );
    let res: Response;
    this.getZceppaProducts();
    this.HttpService.get(this.BASE_URL.BUSINESS_DOMAIN).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        // console.log(res.data);
        this.business_domain = res.data["business_domain"];
      }
    );

    this.images = [
      { id: "01", image_link: "assets/images/BusinessGrowth-login.png" },
    ];

    /** Business details form */
    this.business_detail_form = this.formBuilder.group({
      first_name: ["", Validators.compose([Validators.required])],
      last_name: [""],
      phone: [""],
      email: ["", Validators.compose([Validators.required])],
      business_name: ["", Validators.compose([Validators.required])],
      termsAndCondition: [false, Validators.compose([Validators.requiredTrue])],
    });
  }

  get businessDetailsData() {
    return this.business_detail_form.controls;
  }
  openBackDrop() {
    this.modalService.open(this.accessSuccessModal, {
      backdropClass: "light-blue-backdrop",
    });
  }
  getZceppaProducts() {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.VIEW_ZCEPPA_PRODUCTS,
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        const products: any[] = res.data["product_list"];
        this.products = products;
        // add icon from local based on the product name
        this.products.forEach((prod: any) => {
          prod.icon = this.getProductImageFromName(prod.product_name);
          //add description
          let jsonObj = this.onboardJsonArray.find(
            (element) =>
              element.product_name.toLowerCase() ==
              prod.product_name.toLowerCase()
          );
          prod.description = jsonObj.product_description;
          prod.sort_order = jsonObj.sort_order;
        });
        this.products = this.products.sort((a, b) => a.sort_order - b.sort_order);
        this.selectedProduct = [
          ...Array<boolean>(this.products.length).fill(false),
        ];
      }
    });
  }

  getProductImageFromName(prodName) {
    let prodImage;
    switch (prodName) {
      case "Interact":
        prodImage = "assets/images/onboarding/product-grey-icon/interact.svg";
        break;
      case "Social":
        prodImage = "assets/images/onboarding/product-grey-icon/social.svg";
        break;
      case "Listing Management":
        prodImage = "assets/images/onboarding/product-grey-icon/listing.svg";
        break;
      case "Reviews":
        prodImage = "assets/images/onboarding/product-grey-icon/reviews.svg";
        break;
      case "Appointments":
        prodImage =
          "assets/images/onboarding/product-grey-icon/appointment.svg";
        break;
      case "Messaging":
        // code block
        prodImage = "assets/images/onboarding/product-grey-icon/messaging.svg";
        break;
      default:
      // code block
    }
    return prodImage;
  }

  async getProductDataForDescription() {
    let jsonData = await this.storage.get("onboard_json");
    this.onboardJsonArray = jsonData.product_details;
  }

  clearFields() {
    this.business_details_submit = true;
    this.business_detail_form.reset();
    this.emailnotvalid = true;
    this.product_array = [];
    this.selectedProduct = [
      ...Array<boolean>(this.products.length).fill(false),
    ];
  }
  onBusinessDetailsSubmit(form: FormGroup) {
    this.business_details_submit = false;
    console.log(this.business_detail_form.invalid);
    if (this.business_detail_form.invalid || this.product_array.length == 0) {
      if (this.product_array.length == 0) {
        // this.toastrService.error(`Please choose atleast one or more products.`);
        this.errorUiVisible = true;
        this.errorUiMsg = "Please select at least 1 product.";
      } else if (!this.business_detail_form.value.termsAndCondition) {
        // this.toastrService.error(`Please agree to terms and conditions`);
        this.errorUiVisible = true;
        this.errorUiMsg = "Please agree to terms and conditions.";
      } else {
        this.errorUiVisible = false;
        this.errorUiMsg = "";
      }
      return;
    }
    this.business_details_submit = true;
    this.submitClicked = true;
    let data = { ...this.business_detail_form.value, is_website: false };

    // // data["phone"] = Number(data["phone"].number);
    // let number = data["phone"]["number"];
    // // number = number.replace(" ", "")

    let formatted_number = null;
    let country_code = null;
    if (data["phone"]) {
      country_code = data["phone"]["countryCode"];
      var str1 = data["phone"]["dialCode"];
      var str2 = data["phone"]["e164Number"];

      var str3 = str1.split("");
      formatted_number = str2.slice(str3.length);
    }

    let json = {
      first_name: data["first_name"],
      last_name: null,
      email: data["email"]?.trim(),
      phone: formatted_number,
      // country_code: data["phone"]["countryCode"],
      country_code: country_code,
      business_name: data["business_name"],
      is_website: data["is_website"],
      terms_conditions: data["termsAndCondition"],
      utm_source: this.utmParams.utm_source,
      utm_medium: this.utmParams.utm_medium,
      utm_campaign: this.utmParams.utm_campaign,
      utm_term: this.utmParams.utm_term,
      products: this.product_array,
    };
    let payload = this.commonService.removeEmptyFromObject(json);

    this.HttpService.postOnboard({
      customApiUrl: this.BASE_URL.ONBOARD_WEBSITE_SIGNUP,
      data: payload,
    }).subscribe(
      (response: Response) => {
        if (response.code == 200 || response.code == 201) {
          if (!response.data.is_otp_verified) {
            // this.router.navigate(["/otp"], {
            //   queryParams: {
            //     type: this.BASE_URL.onboardingStatus.type.website,
            //     user_email: data["email"]?.trim(),
            //     phone: formatted_number,
            //   },
            // });
            let userLogin, loginType;
            if (formatted_number) {
              userLogin = formatted_number;
              loginType = this.BASE_URL.loginType.mobile;
            } else {
              userLogin = data["email"]?.trim();
              loginType = this.BASE_URL.loginType.email;
            }
            this.router.navigate(["/signin/verify-email"], {
              queryParams: {
                type: this.BASE_URL.onboardingStatus.type.website,
                user_email: data["email"]?.trim(),
                phone: formatted_number,
                user_login: userLogin,
                loginType: loginType,
              },
            });
          }
          this.submitClicked = false;
          this.errorUiVisible = false;
          this.errorUiMsg = "";
        }
      },
      (err) => {
        this.submitClicked = false;
        this.errorUiVisible = true;
        this.errorUiMsg = err.error.message;
      }
    );
  }

  afterSignup() {
    let res: Response;
    this.openBackDrop();
    setTimeout(() => {
      this.clearFields();
      this.modalService.dismissAll();
    }, 2000);
  }

  createZceppaProduct() {
    let res: Response;
    return new Promise((resolve, reject) => {
      this.HttpService.postRequestAdmin({
        customApiUrl: this.BASE_URL.CREATE_ZCEPPA_PRODUCT(this.newOutlet_id),
        data: {
          product: this.product_array,
        },
      }).subscribe((data) => {
        res = data;
        if (res.code === 200) {
          resolve(true);
        }
      });
    });
  }

  onProductSelect(product_id: string, idx: number) {
    console.log(product_id);
    if (this.selectedProduct[idx] === true) {
      this.selectedProduct[idx] = false;
      this.product_array.splice(this.product_array.indexOf(product_id), 1);
    } else {
      this.selectedProduct[idx] = true;
      this.product_array.push(product_id);
    }
    console.log(this.product_array);
  }
  checkmail() {
    this.emailnotvalid = true;
    if (
      this.businessDetailsData.email.value.match(
        /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,}$/
      )
    ) {
      this.emailnotvalid = true;
    } else {
      this.emailnotvalid = false;
    }
  }

  closeModel() {
    this.modalService.dismissAll();
    this.router.navigate(["../signin"]);
  }

  goToLogin() {
    this.router.navigate(["../signin"]);
  }

  errorBannerClose(data) {
    this.errorUiVisible = false;
    this.errorUiMsg = "";
  }
}
